import React from 'react';
import { VStack, FormControl, Input, Button, FormLabel, FormErrorMessage } from '@chakra-ui/react';

const EmailInputSection = ({ value, onChange, error, onNext }) => (
  <VStack spacing={3} mb={2} align="stretch">
    <FormControl isInvalid={!!error}>
      <FormLabel fontWeight="medium" color="gray.700" mb={1}>
        Email
      </FormLabel>
      <Input type="email" placeholder="Enter Email" size="lg" value={value} onChange={onChange} />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
    <Button colorScheme="blue" size="lg" w="full" onClick={onNext}>
      Next
    </Button>
  </VStack>
);

export default EmailInputSection; 